export default __webpack_public_path__ + "static/media/i2.060f02e3.jpg";